export default __webpack_public_path__ + "static/media/Alicia-Pehrson.2bf4c5a5.jpg";